import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "side-legend-container" }
const _hoisted_2 = { class: "side-legend-wr" }
const _hoisted_3 = {
  key: 0,
  class: "legend column"
}
const _hoisted_4 = {
  key: 1,
  class: "legend column"
}
const _hoisted_5 = { class: "status side-panel yellow" }
const _hoisted_6 = { class: "status side-panel warning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.props.isEstateMap)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "status side-panel gray" }, "Not Released", -1),
            _createElementVNode("div", { class: "status side-panel success" }, "Now Selling", -1),
            _createElementVNode("div", { class: "status side-panel warning" }, "Sold Out", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "status side-panel gray" }, "Not Released", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "status side-panel success" }, "Available", -1)),
            _createElementVNode("div", {
              class: _normalizeClass(["status side-panel", $setup.props.role === $setup.UserRoles.CUSTOMER ? 'light-blue' : 'blue'])
            }, _toDisplayString($setup.props.role === $setup.UserRoles.CUSTOMER ? "Hold" : "Pre-Contract"), 3),
            _createElementVNode("div", _hoisted_5, _toDisplayString($setup.props.role === $setup.UserRoles.CUSTOMER ? "Under Contract" : "Contract Executed"), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString($setup.props.role === $setup.UserRoles.CUSTOMER ? "Sold" : "Settled"), 1),
            ($setup.props.role !== $setup.UserRoles.CUSTOMER)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "status side-panel" }, "Unconditional", -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "status side-panel orange" }, "Option", -1)),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "status side-panel gray-middle" }, "Offline", -1))
                ], 64))
              : _createCommentVNode("", true)
          ])),
      _createVNode($setup["LottrackrPoweredIcon"], {
        class: _normalizeClass(["side-legend-link", { 'side-legend-link-bottom': $setup.props.isEstateMap }])
      }, null, 8, ["class"]),
      (!$setup.props.isEstateMap && $setup.props.role === $setup.UserRoles.CUSTOMER)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "button documents-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openDocuments')))
          }, "Documents"))
        : _createCommentVNode("", true)
    ])
  ]))
}